import { get } from 'lodash/fp';
import { createSelector } from '@reduxjs/toolkit';
import { selectCurrentViewId } from 'app/store/view';

const selectSlice = get('downloadView');
const selectPreparing = createSelector(selectSlice, get('preparingViewIds'));

export const selectIsPreparing = createSelector(
    selectPreparing,
    selectCurrentViewId,
    (preparingForDownload, currentViewId) => preparingForDownload.has(currentViewId)
);
